import * as React from 'react'

import { SearchIcon } from 'lucide-react'
import { observer } from 'mobx-react'

import PhotoSortingTypes from '~/client/src/shared/enums/PhotoSortingTypes'
import { enumToList } from '~/client/src/shared/utils/converters'

import SortingTypeItem from './components/SortingTypeItem'

@observer
export default class PhotoSorter extends React.Component {
  public render() {
    return (
      <div className="px10 bb-light-grey">
        {enumToList(PhotoSortingTypes).map(sortingType => (
          <SortingTypeItem key={sortingType} sortingType={sortingType} />
        ))}
        <SearchIcon
          size={20}
          className="tw:float-right tw:m-2.5 tw:text-primary"
        />
      </div>
    )
  }
}
